<mat-card [class.active]="loan().isSelected" class="loan-card" [routerLink]="['/loan', loan().number]">
  <mat-card-header>
    <mat-card-title>
      <strong>{{loan().nickname}}</strong> 
      ({{loan().number.length > 4 ? '...' : ''}}{{loan().number.slice(-4)}})
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="loan-grid">
      <div class="loan-grid-item" [class.invisible]="loan().statusCode === 1">
        <p class="balance-label">Current Balance</p>
        <p class="balance-amount">{{loan().payoffBalance | currency}}</p>
      </div>
@if (loan().portfolio_code_id === 4) {
  <div class="loan-grid-item" role="alert" aria-live="polite">
    <p class="text-warning"><strong>You cannot make payments through this portal.</strong></p>
  </div>
} @else {
  @if (loan().statusCode !== 1) {
    <div class="loan-grid-item">
      <p class="balance-label">Total Due Amount</p>
      <p class="balance-amount">
        {{loan().nextPaymentDueAmount | currency}}
        <span>&nbsp;includes any Past Due Amount</span>
      </p>
    </div>

    <div class="loan-grid-item" [ngClass]="{'text-danger': loan().pastDue > 0}">
      <p class="balance-label">Past Due Amount</p>
      <p class="balance-amount">
        {{loan().pastDue | currency}} @if (loan().pastDue > 0) {as of {{loan().pastDueDate | date:'shortDate'}} }
      </p>
    </div>
  } @else {
    <div class="loan-grid-item">
      <p class="text-danger"><strong>This account is closed.</strong></p>
    </div>
  }
}

    </div>
  </mat-card-content>
  <mat-card-actions>
    <a mat-stroked-button [routerLink]="[`/loan/${loan().number}/detail`]" class="details-button" (click)="$event.stopPropagation()">View details</a>
  </mat-card-actions>
</mat-card>
